import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { AppContext } from "../Context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { strings } from "../Common/String";
import Button from "../Component/Button";
import Footer from "../footer";
import { MasterService } from "../Services/MasterService";
import { LeadService } from "../Services/LeadService";
import { PATH } from "../Common/Path";
import { getCurrentStep } from "../Common/utils";
import Header from "../Header";
import queryString from "query-string";

function TermsConditions() {
  const {
    user,
    steps,
    setSteps,
    setLoading,
    currentStep,
    setCurrentStep,
    setHasChanges,
    showConfirmDialog,
    closeConfirmDialog,
    clearSession,
  } = useContext(AppContext);

  const [options, setOptions] = useState([]);
  const [apiMessage, setApiMessage] = useState("");
  const history = useHistory();
  const location = useLocation();
  const referralId = queryString.parse(location.search).referral_id || null;
  const [formData, setFormData] = useState({});
  const [scrolledToEnd, setScrolledToEnd] = useState(false);
  const termsBoxRef = useRef(null);

  useEffect(() => {
    setHasChanges(false);
    setLoading(true);
    Promise.all([MasterService.termsConditions()])
      .then((datas) => {
        if (datas[0]) {
          let data = datas[0];
          if (data.success) setOptions(data.terms);
        }
        if (datas[1]) {
          let data = datas[1];
          setCurrentStep(getCurrentStep(data.current_step));
          if (data.success && data.tnc) {
            setFormData({ iConfirm: true });
          } else {
            setFormData({ iConfirm: false });
          }
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (options.length === 0) return;
    const el = termsBoxRef.current;
    if (el && el.scrollHeight <= el.clientHeight) {
      setScrolledToEnd(true);
    }
  }, [options]);

  const handleTermsScroll = () => {
    const el = termsBoxRef.current;
    if (!el || scrolledToEnd) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      setScrolledToEnd(true);
    }
  };

  useEffect(() => {
    steps.forEach((step) => {
      if (step.id === currentStep) step.status = 1;
      else if (step.id < currentStep) step.status = 2;
    });
    setSteps(steps);
  }, [currentStep]);

  const handleAgree = () => {
    const body = { mobile: user.mobile, email: user.email, tnc: true };
    setApiMessage("");
    setLoading(true);
    LeadService.postTermsConditions(body)
      .then((data) => {
        if (data.success) {
          history.push(
            `${PATH.CREATEPASSWORD_PAGE}${referralId ? `?referral_id=${referralId}` : ""}`
          );
        } else {
          setApiMessage(data.error);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  const handleExitEntry = () => {
    closeConfirmDialog();
    clearSession();
    history.push(PATH.MOBILE_PAGE);
  };

  const handleDisagree = () => {
    showConfirmDialog(
      strings.tnc_disagree_message,
      undefined,
      handleExitEntry,
      strings.ok,
      strings.cancel_title
    );
  };

  return (
    <>
      <Header />
      <main className="inner pb-4">
        <div className="container">
          <div className="row">
            <div className="col-md-30 mt-6 ml-5 pl-5">
              <div className="images-add">
                <img
                  src={process.env.PUBLIC_URL + "/img/terms-illustration.png"}
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-50 ml-5">
              <div
                className="l-box"
                tabIndex={0}
                ref={termsBoxRef}
                onScroll={handleTermsScroll}
              >
                <h1 className="text-left pb-4">{strings.termsconditions}</h1>
                <div className="col-md-12">
                  <ol type="1" className="list-ad">
                    {options.map((item, index) => (
                      <li key={index} style={{ paddingLeft: "9px" }}>
                        <p>{item.condition}</p>
                      </li>
                    ))}
                  </ol>
                </div>
                <div
                  className="select-plan terms"
                  style={{ backgroundColor: "#f5f9ff" }}
                >
                  <p className="mb-0">{strings.tnc_agree_content}</p>
                </div>
                <div
                  id="txterror"
                  name="txterror"
                  className="api-errormessage text-danger mh-25"
                >
                  {apiMessage}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row mh-64">
            <div className="col-md-30" />
            <div className="col-md-50 ml-5">
              <div
                className="pt-3 tnc-actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexWrap: "wrap",
                  gap: "12px",
                }}
              >
                <Button
                  classes="inp-outline"
                  classes1={!scrolledToEnd ? "disabled-button" : ""}
                  label={strings.tnc_disagree_btn}
                  btndisable={!scrolledToEnd}
                  click={handleDisagree}
                />
                <Button
                  classes="inp"
                  classes1={!scrolledToEnd ? "disabled-button" : ""}
                  label={strings.tnc_agree_btn}
                  btndisable={!scrolledToEnd}
                  click={handleAgree}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default TermsConditions;
